export default __webpack_public_path__ + "static/media/frontend.b8b7f475.png";